export default "__VITE_ASSET__4S8jibDL__"